import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  SecondaryHeaderDataProps, SecondaryHeaderProps, SecondaryHeaderThemeProps,
} from '../../components/navigation/header/secondaryHeader/SecondaryHeader';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { secondaryHeaderHeight } from '../../components/navigation/header/header.utils';
import { AMPLogo } from './AMPLogo';
import { AMPSecondaryLinks } from './AMPSecondaryLinks';
import { createStyleForBoxShadow } from '../../../theming/boxShadow';
import { BaseUnit } from '../../../theming/baseUnitDefinition';

const componentConfigThemeKey = 'secondaryHeader';

const createStyle = (baseUnit: BaseUnit, backgroundColor: string) => {
  return StyleSheet.create({
    wrapper: {
      backgroundColor,
      position: 'relative',
      height: `${secondaryHeaderHeight}px`,
      display: 'grid',
      gridAutoFlow: 'column',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'flex-start',
      zIndex: 50,
      gridColumnGap: `${baseUnit}px`,
      paddingLeft: `${baseUnit}px`,
    },
  });
};

export const AMPSecondaryHeaderComponent: React.FunctionComponent<SecondaryHeaderProps> = props => {
  const { baseUnit, backgroundColor, boxShadowTypeNormal, moreLinksText, links, logo, pagePath } = props;
  const style = createStyle(baseUnit, backgroundColor);
  const boxShadowStyle = createStyleForBoxShadow({ boxShadowTypeNormal });
  return (
    <div className={css(style.wrapper, boxShadowStyle.style)}>
      {logo ? <AMPLogo {...logo} /> : null}
      {links ? <AMPSecondaryLinks links={links} moreLinksText={moreLinksText} pagePath={pagePath} /> : null}
    </div>
  );
};

const mapThemeProps = (theme: SecondaryHeaderThemeProps) => {
  return {
    baseUnit: theme.baseUnit,
    backgroundColor: theme.backgroundColor,
    boxShadowTypeNormal: theme.boxShadowTypeNormal,
    fontSizesStyles: theme.fontSizesStyles,
  };
};

export const AMPSecondaryHeader = (props: SecondaryHeaderDataProps) => {
  const themeContext = useTheme(mapThemeProps, componentConfigThemeKey);
  return <ErrorBoundary><AMPSecondaryHeaderComponent {...themeContext} {...props} /></ErrorBoundary>;
};
